/*
* Main Configuration
*/
export default function () {
  return {
    siteUrl: 'customusb.com',
    localSiteUrl: 'new.localcusb',
    siteName: 'CustomUSB',
    phone: '(800) 447-0149',
    phoneLocal: '(847) 205-5200',
    phoneGlobal: '+1 (888) 295-6064',
    email: 'sales@customusb.com',
    emailGraphics: 'graphics@customusb.com',
    siteDescr: 'CustomUSB | Memorable. Powerful. Loud.',
    location: '1360 Abbott Ct.Buffalo Grove, IL 60089',
    holdingName: 'IPMedia Holdings, Inc.',
    enableMultiLang: false
  }
}
